const TASK_PHASE_DATA = [
  {
    key: "Init",
    value: 0,
    text: "同步进程初始化"
  },
  {
    key: "LoadCache",
    value: 1,
    text: "加载同步缓存"
  },
  {
    key: "UpdateEntry",
    value: 2,
    text: "更新节点信息"
  },
  {
    key: "UpdateGroup",
    value: 3,
    text: "调整通讯组成员"
  },
  {
    key: "UpdateRsLimit",
    value: 4,
    text: "设置收发权限"
  },
  {
    key: "UpdateArchive",
    value: 5,
    text: "设置邮件归档"
  },
  {
    key: "DeleteEntry",
    value: 6,
    text: "记录删除账户"
  },
  {
    key: "ProcessDeleted",
    value: 7,
    text: "处理删除账户"
  },
  {
    key: "ProcessDisabled",
    value: 8,
    text: "处理禁用账户"
  },
  {
    key: "RemoveEntry",
    value: 9,
    text: "删除非账户节点"
  }
];
const TASK_PHASE = {};
const TASK_PHASE_TEXT = {};
for (let item of TASK_PHASE_DATA) {
  TASK_PHASE[item.key] = item.value;
  TASK_PHASE_TEXT[item.value] = item.text;
}
export { TASK_PHASE, TASK_PHASE_TEXT };
